export const R_DASHBOARD = 1
export const R_USER_SETTINGS = 2
export const R_USERS = 3
export const R_CLIENTS = 4
export const R_TRANSACTIONS= 5
export const R_NVI = 6

